var RENDERS;
(function (RENDERS) {
    RENDERS["TITLE"] = "PAPER_TITLE.render";
    RENDERS["AUTHORS"] = "PAPER_AUTHORS.render";
    RENDERS["ABST"] = "PAPER_ABST.render";
    RENDERS["TOPICS"] = "PAPER_TOPICS.render";
    RENDERS["PDF"] = "PAPER_PDF.render";
    RENDERS["WEBSITE"] = "PAPER_WEBSITE.render";
    RENDERS["JOURNAL"] = "PAPER_JOURNAL.render";
    RENDERS["ORGANIZATIONS"] = "PAPER_ORGANIZATIONS.render";
    RENDERS["PUBLISH_TIME"] = "PAPER_PUBLISH_TIME.render";
})(RENDERS || (RENDERS = {}));
export const PAPER_COLUMNS_MAP = {
    TITLE: {
        width: 360,
        renderer: RENDERS.TITLE,
    },
    PUBLISH_TIME: {
        width: 160,
        renderer: RENDERS.PUBLISH_TIME,
    },
    ABSTRACT: {
        renderer: RENDERS.ABST,
        width: 600,
    },
    AUTHORS: {
        width: 190,
        renderer: RENDERS.AUTHORS,
    },
    PDF: {
        width: 240,
        renderer: RENDERS.PDF,
    },
    TOPICS: {
        width: 400,
        renderer: RENDERS.TOPICS,
    },
    ORGANIZATIONS: {
        width: 240,
        renderer: RENDERS.ORGANIZATIONS,
    },
    JOURNAL: {
        width: 240,
        renderer: RENDERS.JOURNAL,
    },
    CITATION_COUNT: {
        width: 110,
    },
    WEBSITE: {
        width: 200,
        renderer: RENDERS.WEBSITE,
    },
};
